export { default as SearchResultKb } from './result-kb';
